import Question from './question.js'
import Parkour from 'toxilibs/parkour.js'
import eventBus from 'toxilibs/event_bus_queued.js'

function Level (params) {
    this.id           = params.name
    this.name         = params.name
    this.dependencies = params.dependencies
    this.questions    = new Parkour({
        onStepReached: function () {
            this.current.errors = 0
            this.current.tries  = 0
            eventBus.emit('question changed')
        },
        onStepCompleted: function () {
            if (!this.isLastStep()) {
                this.goTo(this.currentSignature + 1)
            }
        },
        onLastStepCompleted: function () {
            eventBus.emit('questions parkour ended')
        }
    })
}

Level.prototype.addQuestion = function (params) {
    this.questions.add(new Question(params))
}

export default Level

